import { ScrapingTab } from './Scraping';
import { Tabs, Tab } from '../../components';
import { KnowledgeTab } from './Knowledge';
import CompressorTab from './TextCompressorNew';
import { PERMISSIONS } from '../../shared/constants/permissions';
import { PresentationsManagementTab } from './PresentationsManagement';
import { useTabPersistence } from '../../shared';

type TabsEnum = 'knowledge' | 'scraping' | 'compressor' | 'presentations';

const KnowledgeManagementPage = () => {
  const tabPersistenceConfig = {
    paramName: 'tab',
    defaultTab: 'knowledge' as TabsEnum,
    updateHistory: true,
  };

  const availableTabs: TabsEnum[] = [
    'knowledge',
    'scraping',
    'compressor',
    'presentations',
  ];

  const { selectedTab, setSelectedTab, isReady } = useTabPersistence(
    tabPersistenceConfig,
    availableTabs
  );

  if (!isReady) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Tabs<TabsEnum>
        tabs={[
          {
            name: 'knowledge',
            label: 'Knowledge',
            action: PERMISSIONS.MANAGE_KNOWLEDGE,
          },
          {
            name: 'scraping',
            label: 'Scraping',
            action: PERMISSIONS.MANAGE_SCRAPER,
          },
          {
            name: 'compressor',
            label: 'Text Compressor',
            action: PERMISSIONS.MANAGE_KNOWLEDGE,
          },
          {
            name: 'presentations',
            label: 'Presentations Management',
            action: PERMISSIONS.MANAGE_KNOWLEDGE,
          },
        ]}
        activeTab={selectedTab}
        onChange={setSelectedTab}
        contentClassName="mt-md"
      >
        <Tab name="knowledge">
          <KnowledgeTab />
        </Tab>
        <Tab name="scraping">
          <ScrapingTab />
        </Tab>
        <Tab name="compressor">
          <CompressorTab />
        </Tab>
        <Tab name="presentations">
          <PresentationsManagementTab />
        </Tab>
      </Tabs>
    </>
  );
};

export default KnowledgeManagementPage;
